// src/crm/pipeline/DealCard.tsx
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { Deal } from '../../lib/types'

const COMP_MODEL_LABEL: Record<string, string> = {
  flat: 'Flat',
  gifting: 'Gifting',
  promo_affiliate: 'Affiliation',
  hybrid: 'Hybride',
}

interface DealCardProps {
  deal: Deal & { creatorName?: string }
}

export function DealCard({ deal }: DealCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: deal.id })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    background: 'var(--elevated)',
    border: '1px solid var(--line)',
    borderRadius: '8px',
    padding: '0.75rem',
    cursor: isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
    touchAction: 'none',
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div style={{ fontWeight: 600, fontSize: '0.8125rem', color: 'var(--fg)', marginBottom: '0.25rem' }}>
        {deal.creatorName ?? '—'}
      </div>
      {deal.amount !== null && (
        <div style={{ fontSize: '0.75rem', color: 'var(--bronze)', fontFamily: 'var(--mono)', marginBottom: '0.25rem' }}>
          {deal.amount.toLocaleString('fr-FR')} {deal.currency}
        </div>
      )}
      {deal.compModel && (
        <span style={{
          display: 'inline-block',
          fontSize: '0.6875rem',
          fontWeight: 600,
          color: 'var(--muted)',
          background: 'var(--raised)',
          border: '1px solid var(--line)',
          borderRadius: '3px',
          padding: '0.0625rem 0.3125rem',
          letterSpacing: '0.02em',
        }}>
          {COMP_MODEL_LABEL[deal.compModel] ?? deal.compModel}
        </span>
      )}
    </div>
  )
}
